"use client";

import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const CaseStudyCard = ({ caseStudy, onViewDetails, className = "" }) => {
  return (
    <div
      className={`bg-card border border-border rounded-lg overflow-hidden shadow-subtle hover:shadow-dramatic transition-all duration-300 group flex flex-col h-full ${className}`}
    >
      <div className="relative h-48 overflow-hidden">
        {caseStudy.image ? (
          <Image
            src={caseStudy.image}
            alt={caseStudy.alt || ""}
            fill
            priority
            sizes="100vw"
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
          />
        ) : caseStudy.website ? (
          <iframe
            src={caseStudy.website}
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
            loading="eager"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            referrerPolicy="no-referrer"
          />
        ) : null}

        <div className="absolute inset-0 bg-gradient-to-t from-black opacity-80" />

        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex flex-wrap gap-2 mb-2">
            {caseStudy.services.slice(0, 2).map((service, index) => (
              <span
                key={index}
                className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full"
              >
                {service}
              </span>
            ))}
          </div>

          <h3 className="text-xl font-headline font-bold text-white">
            {caseStudy.title}
          </h3>
        </div>
      </div>

      <div className="p-6 space-y-4 flex flex-col flex-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm sm:text-xl font-bold text-red-600">
              {caseStudy.client}
            </p>
            <p className="text-xs sm:text-lg font-bold text-muted-foreground">
              {caseStudy.industry}
            </p>
          </div>
        </div>

        <p className="text-sm text-foreground leading-relaxed line-clamp-4 min-h-[5.5rem]">
          {caseStudy.shortdescription}
        </p>
        <div className="mt-auto space-y-4">
          <div className="grid grid-cols-3 items-stretch gap-3 pt-4 border-t border-border">
            {caseStudy.metrics.slice(0, 3).map((metric, index) => (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-1">
                  <Icon name={metric.icon} size={20} className="text-primary" />
                </div>

                <div className="text-lg font-headline font-black text-primary">
                  {metric.value}
                </div>

                <div className="text-xs text-muted-foreground">
                  {metric.label}
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => onViewDetails(caseStudy.id)}
            className="flex items-center justify-center lg:space-x-2 w-full px-6 py-3 text-xs font-semibold uppercase text-white transition-command sm:text-sm bg-red-700 rounded-lg shadow-emergency hover:bg-accent/90"
          >
            <span>View Full Case Study</span>
            <Icon name="ArrowRightIcon" size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;
